import moment from 'moment';

import {FORMATO_FECHA_HORA, FORMATO_FECHA_ANIO_MES} from '../Utils/constants';

/**
 * Convertir la fecha al formato especificado.
 * @param {Date} date Fecha para convertir.
 * @returns Fecha convertida.
 */
export function convertirDate(date: Date) {
    return moment(date).format(FORMATO_FECHA_HORA);
}

/**
 * Convertir la fecha al formato especificado.
 * @param {Date} date Fecha para convertir.
 * @returns Fecha convertida.
 */
export function convertirDateAnioMEs(date: Date) {
    return moment(date).format(FORMATO_FECHA_ANIO_MES);
}

export function timestampDescarga() {
  const now = new Date();

  const pad = (n: number) => n.toString().padStart(2, '0');

  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1); // Los meses van de 0 a 11
  const day = pad(now.getDate());
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());

  const timestamp = `${year}${month}${day}${hours}${minutes}`;
  return timestamp;
}